import React from "react";
import {
  MapContainer,
  TileLayer,
  Marker,
  Popup,
  useMap,
} from "react-leaflet";
import "leaflet/dist/leaflet.css";
import L from "leaflet";

// =========================================================
// FIX LEAFLET DEFAULT MARKER ICON
// =========================================================

delete L.Icon.Default.prototype._getIconUrl;

L.Icon.Default.mergeOptions({
  iconRetinaUrl:
    "https://unpkg.com/leaflet@1.9.4/dist/images/marker-icon-2x.png",

  iconUrl:
    "https://unpkg.com/leaflet@1.9.4/dist/images/marker-icon.png",

  shadowUrl:
    "https://unpkg.com/leaflet@1.9.4/dist/images/marker-shadow.png",
});

// =========================================================
// MAP VIEW
// =========================================================

function MapView({
  lat,
  lng,
  destinationLat,
  destinationLng,
}) {
  const map = useMap();

  React.useEffect(() => {
    const points = [];

    if (
      Number.isFinite(Number(lat)) &&
      Number.isFinite(Number(lng))
    ) {
      points.push([
        Number(lat),
        Number(lng),
      ]);
    }

    if (
      Number.isFinite(Number(destinationLat)) &&
      Number.isFinite(Number(destinationLng))
    ) {
      points.push([
        Number(destinationLat),
        Number(destinationLng),
      ]);
    }

    if (points.length === 1) {
      map.setView(points[0], 15);
    }

    if (points.length === 2) {
      map.fitBounds(points, {
        padding: [40, 40],
      });
    }
  }, [
    lat,
    lng,
    destinationLat,
    destinationLng,
    map,
  ]);

  return null;
}

// =========================================================
// DELIVERY MAP
// =========================================================

export default function DeliveryMap({
  lat,
  lng,
  destinationLat,
  destinationLng,
}) {
  const hasLiveLocation =
    Number.isFinite(Number(lat)) &&
    Number.isFinite(Number(lng));

  const hasDestination =
    Number.isFinite(Number(destinationLat)) &&
    Number.isFinite(Number(destinationLng));

  if (
    !hasLiveLocation &&
    !hasDestination
  ) {
    return null;
  }

  const center = hasLiveLocation
    ? [Number(lat), Number(lng)]
    : [
        Number(destinationLat),
        Number(destinationLng),
      ];

  return (
    <div
      className="rounded-3xl overflow-hidden mt-4"
      style={{
        height: 300,
        width: "100%",
      }}
    >
      <MapContainer
        center={center}
        zoom={15}
        style={{
          height: "100%",
          width: "100%",
        }}
      >

        <MapView
          lat={lat}
          lng={lng}
          destinationLat={destinationLat}
          destinationLng={destinationLng}
        />

        <TileLayer
          url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
          attribution="&copy; OpenStreetMap"
        />

        {/* =====================================
            DELIVERY PARTNER
        ===================================== */}

        {hasLiveLocation && (
          <Marker
            position={[
              Number(lat),
              Number(lng),
            ]}
          >
            <Popup>
              🚴 Delivery partner is here
            </Popup>
          </Marker>
        )}

        {/* =====================================
            CUSTOMER DESTINATION
        ===================================== */}

        {hasDestination && (
          <Marker
            position={[
              Number(destinationLat),
              Number(destinationLng),
            ]}
          >
            <Popup>
              📍 Your location
            </Popup>
          </Marker>
        )}

      </MapContainer>
    </div>
  );
}